import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscribedMap } from "../../../Pages/SubscribedMap/ISubscribed";

export const DeleteSubscribedMapSlice = createSlice({
  name: "DeleteSubscribedMap",
  initialState: {} as IReduxState<ISubscribedMap>,
  reducers: {
    deleteSubscribedMap: (state, _) => {
      state.isLoading = true;
    },
    successdeleteSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteSubscribedMapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSubscribedMap,
  failuredeleteSubscribedMap,
  successdeleteSubscribedMap,
  clearDeleteSubscribedMapResponse,
} = DeleteSubscribedMapSlice.actions;

export default DeleteSubscribedMapSlice.reducer;
